export default __webpack_public_path__ + "public/images/services/Chat@2x.png?20faae5e";